import { BehaviorSubject } from 'rxjs';

import Case from '../models/Case';

export default class CasesRepository {
  cases$ = new BehaviorSubject([]);
  selectedCase$ = new BehaviorSubject(null);
  caseToComplete$ = new BehaviorSubject(null);
  notPaidCases$ = new BehaviorSubject([]);
  notPaidCasesTotal$ = new BehaviorSubject(0);

  constructor({ casesService }) {
    this.casesService = casesService;
  }

  getCases(criteria) {
    return this.casesService.getCases(criteria);
  }

  async getNotPaidCases() {
    const cases = await this.casesService.getNotPaidCases();
    cases.data = cases.data.map((item) => new Case(item));

    this.notPaidCases$.next(cases.data);
    this.notPaidCasesTotal$.next(cases.total);

    return cases.data;
  }

  getLinkViewer(id) {
    return this.casesService.getLinkViewer(id);
  }

  claimCase(id) {
    return this.casesService.claimCase(id);
  }

  rejectCase(id) {
    return this.casesService.rejectCase(id);
  }

  discardReview(id) {
    return this.casesService.discardReview(id);
  }

  sendForReview(id) {
    return this.casesService.sendForReview(id);
  }

  startReview(id) {
    return this.casesService.startReview(id);
  }

  getCase(id, token = null) {
    return this.casesService.getCase(id, token);
  }

  async getCaseById(id) {
    const caseData = await this.casesService.getCase(id);
    return new Case(caseData);
  }

  cancelReview(id) {
    return this.casesService.cancelReview(id);
  }

  signOff(id) {
    return this.casesService.signOff(id);
  }

  revertSignOff(caseIdd) {
    return this.casesService.revertSignOff(caseIdd);
  }

  submitCase(payload, progress$ = new BehaviorSubject(0)) {
    return this.casesService.submitCase(payload, progress$);
  }

  submitClinicUpload(payload) {
    return this.casesService.submitClinicUpload(payload);
  }

  requestVideoReport(payload, progress$ = new BehaviorSubject(0)) {
    return this.casesService.requestVideoReport(payload, progress$);
  }

  requestUploadSharedReport(payload, progress$) {
    return this.casesService.requestUploadSharedReport(payload, progress$);
  }

  requestUploadSharedLinkReport(payload, progress$) {
    return this.casesService.requestUploadSharedLinkReport(payload, progress$);
  }

  requestMailReportForPatient(payload) {
    return this.casesService.requestMailReportForPatient(payload);
  }

  completeCase(payload, progress$ = new BehaviorSubject(0)) {
    return this.casesService.completeCase(payload, progress$);
  }

  completeUploadSharedReportForPatient(payload) {
    return this.casesService.completeUploadSharedReportForPatient(payload);
  }

  rejectPendingUploadCase(id) {
    return this.casesService.rejectPendingUploadCase(id);
  }

  submitClinicUploadFiles(payload, progress$ = new BehaviorSubject(0)) {
    return this.casesService.submitClinicUploadFiles(payload, progress$);
  }

  submitOnlinePortalAccess(payload) {
    return this.casesService.submitOnlinePortalAccess(payload);
  }

  archiveCase(id) {
    return this.casesService.archiveCase(id);
  }

  unarchiveCase(id) {
    return this.casesService.unarchiveCase(id);
  }

  submitRate(id, reportRate) {
    return this.casesService.submitRate(id, reportRate);
  }

  bypassImagesAndReport(id) {
    return this.casesService.bypassImagesAndReport(id);
  }

  addAdditonalFile(payload, progress$ = new BehaviorSubject(0)) {
    return this.casesService.addAdditionalFile(payload, progress$);
  }
}
